DialogController = App.loadClass 'core::Angular/DialogController'

class exports.InvalidShapefileDialogController extends DialogController
    constructor: (@state, @scope, @transitions, @modalInstance, data) ->
        super(@scope, @transitions, @modalInstance)

        @scope.title = 'Invalid Shapefiles'
        @scope.absolute_errors = false
        @scope.files = []

        for i, name of data.data
            @scope.files.push(name)
